// =============================================================
// Files placed INSIDE a note (migration 234) — the web half.
//
// uploadNotebookFile: ask the API for a write link, PUT the bytes straight to
// Blob Storage, confirm, and hand back the stable reference the block stores
// (`harvus-file://notebook/<id>`). createNotebookFileResolver turns a reference
// back into a short-lived read link when the editor renders it.
//
// Used by NotesApp through NoteBodyEditor's `uploadFile` / `resolveFileUrl`, so
// BlockNote's own image/file blocks, drag-and-drop and paste all go through it.
// =============================================================

import { createNotebookFileResolver } from '@harvus/shared';

export class NotebookFileError extends Error {}

export async function uploadNotebookFile(api, noteId, file) {
  const fileName = file.name || (file.type === 'image/png' ? 'sketch.png' : 'file');
  const contentType = file.type || 'application/octet-stream';
  const res = await api.post(`notebook/${noteId}/files`, { fileName, contentType, sizeBytes: file.size });
  if (!res?.available) throw new NotebookFileError(res?.error || 'Files cannot be added to notes yet.');
  const put = await fetch(res.uploadUrl, {
    method: 'PUT',
    headers: { 'x-ms-blob-type': 'BlockBlob', 'Content-Type': contentType },
    body: file,
  });
  if (!put.ok) throw new NotebookFileError(`The upload failed (${put.status}).`);
  await api.post(`notebook-files/${res.fileId}/confirm`, {});
  return { url: res.url, fileId: res.fileId, blockType: res.blockType, fileName: res.fileName };
}

export const makeNotebookFileResolver = (api) => createNotebookFileResolver({ get: (path) => api.get(path) });
